module.exports = __webpack_public_path__ + "static/AdobeStock_203384096-f680654326e85386b4da2be3da4b1d1d.jpg";